<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right spa-page">
      <div class="dp-dept-hint">
        <span class="dp-dept-hint__label">所属机构</span>
        <span class="dp-dept-hint__value">{{ currentDepartmentName || '未选择' }}</span>
      </div>
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
        <template slot="prefix">
          <el-form-item label="校区" class="toolbar-search-item">
            <el-select
              v-model="selectedCampusFilter"
              placeholder="全部"
              clearable
              size="small"
              class="toolbar-field-w-xl"
              @change="onCampusFilterChange">
              <el-option label="全部" :value="0"></el-option>
              <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name" :value="c.Id"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </toolbar>
      <div class="tbl-scroll-host">
        <el-table :data="tableData" v-loading="listLoading" class="custom-tbl" height="100%" style="width: 100%">
            <el-table-column label="类型" width="90" align="center">
              <template slot-scope="scope">
                {{ scope.row.PortraitScope === 1 ? '校级' : '班级' }}
              </template>
            </el-table-column>
            <el-table-column label="校区" width="120" align="center">
              <template slot-scope="scope">
                {{ getCampusLabel(scope.row.CampusId) }}
              </template>
            </el-table-column>
            <el-table-column prop="Category" label="分类" width="80" align="center"></el-table-column>
            <el-table-column prop="Theme" label="主题" align="center"></el-table-column>
            <el-table-column label="外链" width="70" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.IsExternalLink === 1 ? 'success' : 'info'" size="mini">
                  {{ scope.row.IsExternalLink === 1 ? '是' : '否' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="ExternalLink" label="链接" min-width="120" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column label="创建" width="168" align="center">
              <template slot-scope="scope">
                <div class="merged-meta">
                  <div class="merged-meta-line">{{ scope.row.CreateBy || '—' }}</div>
                  <div class="merged-meta-sub">{{ formatDateTimeCell(scope.row.CreateTime) }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="修改" width="168" align="center">
              <template slot-scope="scope">
                <div class="merged-meta">
                  <div class="merged-meta-line">{{ scope.row.ModifyBy || '—' }}</div>
                  <div class="merged-meta-sub">{{ formatDateTimeCell(scope.row.UpdateTime) }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140" align="center">
              <template slot-scope="scope">
                <el-link type="primary" :underline="false" @click="handleEdit(scope.row)">编辑</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link type="danger" :underline="false" @click="handleDelete(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <el-col :span="24" class="toolbar">
        <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :current-page="page"
          :page-size="pageSize" @current-change="handleCurrentChange" style="float: right">
        </el-pagination>
      </el-col>

      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
        <el-form :model="form" :rules="rules" ref="dataForm" label-width="100px" class="dialog-form">
          <el-form-item label="校区" prop="CampusId">
            <el-select v-model="form.CampusId" placeholder="请选择校区" filterable style="width: 100%">
              <el-option v-for="c in campusOptions" :key="'f-' + c.Id" :label="c.Name" :value="c.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类" prop="Category">
            <el-select v-model="form.Category" placeholder="请选择分类" style="width: 100%">
              <el-option label="活动" value="活动"></el-option>
              <el-option label="环境" value="环境"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主题" prop="Theme">
            <el-input v-model="form.Theme" placeholder="请输入主题"></el-input>
          </el-form-item>
          <el-form-item label="是否外链" prop="IsExternalLink">
            <el-switch v-model="form.IsExternalLink" :active-value="1" :inactive-value="0" active-text="是"
              inactive-text="否" @change="onExternalLinkChange"></el-switch>
          </el-form-item>
          <el-form-item label="外链地址" prop="ExternalLink" v-if="form.IsExternalLink === 1">
            <el-input v-model="form.ExternalLink" type="textarea" :rows="2" placeholder="完整链接"></el-input>
          </el-form-item>
          <el-form-item label="活动意义" prop="ActivityMeaning">
            <el-input type="textarea" v-model="form.ActivityMeaning" :rows="3"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="ResultDescription">
            <el-input type="textarea" v-model="form.ResultDescription" :rows="3"></el-input>
          </el-form-item>
          <el-form-item label="配图">
            <el-upload list-type="picture-card" action="#" :auto-upload="false"
              :on-change="(file, list) => { deferredPictureCardChange(file, list, 'fileList'); updateImagesPath() }"
              :on-remove="(file, list) => { deferredPictureCardRemove(file, list, 'fileList'); updateImagesPath() }"
              :file-list="fileList" :on-preview="handlePictureCardPreview">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="previewVisible" append-to-body>
              <img width="100%" :src="previewImageUrl" alt="">
            </el-dialog>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="submitLoading" @click="submitForm">确认提交</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from '../../../components/DepartmentPane'
import Toolbar from '../../../components/Toolbar'
import util from '../../../../util/date'
import { getButtonList } from '../../../promissionRouter'
import { BaseApiUrl } from '../../../api/base';
import { getClassActivityList, saveClassActivity, removeClassActivity } from '../../../api/modules/big-screen';
import { getCampusList } from '../../../api/modules/misc';
import { normalizeDeptId, deptIdsEqual } from '../../../utils/deptCascaderProps';
export default {
  name: 'SchoolPortraitActivityManage',
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      BaseApiUrl: BaseApiUrl,
      DepartmentId: 0,
      currentDepartmentName: '',
      /** 列表筛选：0 表示不按校区过滤 */
      selectedCampusFilter: 0,
      /** 与 DutyStaff / MoralMallAdmin 一致：getCampusList 返回的校区部门列表 */
      campusOptions: [],
      buttonList: [],
      searchList: [
        { label: '关键字', key: 'key' }
      ],
      filters: {},
      listLoading: false,
      total: 0,
      page: 1,
      pageSize: 10,
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      uploadUrl: BaseApiUrl + '/images/Upload/Pic',
      fileList: [],
      previewVisible: false,
      previewImageUrl: '',
      form: {
        Id: 0,
        DepartmentId: 0,
        CampusId: undefined,
        SortIndex: 0,
        Category: '活动',
        Theme: '',
        ActivityMeaning: '',
        ResultDescription: '',
        Images: '',
        IsExternalLink: 0,
        ExternalLink: ''
      },
      rules: {
        CampusId: [
          { required: true, message: '请选择校区', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              const campusId = normalizeDeptId(value)
              if (!campusId) {
                callback(new Error('请选择具体校区'))
                return
              }
              if (!this.campusOptions.some(c => deptIdsEqual(c.Id, campusId))) {
                callback(new Error('请选择有效校区'))
                return
              }
              callback()
            },
            trigger: 'change'
          }
        ],
        Theme: [{ required: true, message: '请输入主题', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
  },
  methods: {
    /** 从 sessionStorage / localStorage 读取 campusId（与登录身份缓存一致） */
    readCachedCampusId() {
      const raw = sessionStorage.getItem('campusId') || localStorage.getItem('campusId')
      return normalizeDeptId(raw)
    },
    /** 与 DutyStaff.loadCampusOptions 相同参数拉取校区下拉 */
    loadCampusOptionsThenApplyDefault() {
      if (!normalizeDeptId(this.DepartmentId)) {
        this.campusOptions = []
        this.selectedCampusFilter = 0
        return
      }
      getCampusList({ page: 1, intPageSize: 999, departmentId: this.DepartmentId }).then(res => {
        if (res.data.success) {
          this.campusOptions = res.data.response.data || []
        } else {
          this.campusOptions = []
        }
        const cached = this.readCachedCampusId()
        if (cached && this.campusOptions.some(c => deptIdsEqual(c.Id, cached))) {
          this.selectedCampusFilter = cached
        } else {
          this.selectedCampusFilter = 0
        }
        this.getList()
      }).catch(() => {
        this.campusOptions = []
        this.selectedCampusFilter = 0
        this.getList()
      })
    },
    getCampusLabel(campusId) {
      const id = normalizeDeptId(campusId)
      if (!id) return '—'
      const c = this.campusOptions.find(x => deptIdsEqual(x.Id, id))
      return c ? c.Name : String(campusId)
    },
    formatDateTimeCell(val) {
      if (!val) return ''
      return util.formatDate.format(new Date(val), 'yyyy-MM-dd hh:mm:ss')
    },
    onExternalLinkChange(val) {
      if (val !== 1) this.form.ExternalLink = ''
    },
    treeNodeClick(data) {
      this.DepartmentId = data.value
      this.currentDepartmentName = data.label
      this.page = 1
      this.loadCampusOptionsThenApplyDefault()
    },
    onCampusFilterChange(val) {
      if (val === '' || val === null || val === undefined) {
        this.selectedCampusFilter = 0
      }
      this.page = 1
      this.getList()
    },
    callFunction(item) {
      if (typeof item.search === 'object') {
        this.filters = item.search
      } else {
        this.filters = { key: item.search }
      }
      this[item.Func].apply(this, item)
    },
    handleQuery() {
      this.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },
    getList() {
      if (this.DepartmentId === 0) {
        this.$message.warning('请先从左侧选择学校或校区')
        return
      }
      this.listLoading = true
      const para = {
        page: this.page,
        pageSize: this.pageSize,
        departmentId: this.DepartmentId,
        key: this.filters.key || '',
        portraitScope: 1
      }
      const filterCampusId = normalizeDeptId(this.selectedCampusFilter)
      if (filterCampusId) {
        para.campusId = filterCampusId
      }
      getClassActivityList(para).then(res => {
        if (res.data.success) {
          this.total = res.data.response.dataCount
          this.tableData = res.data.response.data
        } else {
          this.$message.error(res.data.msg)
        }
        this.listLoading = false
      }).catch(() => { this.listLoading = false })
    },
    handleAdd() {
      if (!normalizeDeptId(this.DepartmentId)) {
        this.$message.warning('请先从左侧选择学校或校区')
        return
      }
      if (!this.campusOptions || this.campusOptions.length === 0) {
        this.$message.warning('当前机构下没有可选校区，请确认部门树中学校下已维护校区，或更换左侧机构')
        return
      }
      this.dialogTitle = '新增校级活动/环境'
      const defaultCampus = normalizeDeptId(this.selectedCampusFilter) || this.readCachedCampusId()
      const hasDefault = defaultCampus && this.campusOptions.some(c => deptIdsEqual(c.Id, defaultCampus))
      this.form = {
        Id: 0,
        DepartmentId: this.DepartmentId,
        CampusId: hasDefault ? defaultCampus : undefined,
        SortIndex: 0,
        Category: '活动',
        Theme: '',
        ActivityMeaning: '',
        ResultDescription: '',
        Images: '',
        IsExternalLink: 0,
        ExternalLink: ''
      }
      this.deferredPictureCardClear('fileList')
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.clearValidate()
      })
    },
    async handleEdit(row) {
      if (!this.campusOptions || this.campusOptions.length === 0) {
        this.$message.warning('当前机构下没有可选校区，无法编辑归属，请先维护校区或切换左侧机构')
        return
      }
      this.dialogTitle = '编辑校级活动/环境'
      this.form = Object.assign({}, row)
      if (this.form.IsExternalLink === undefined || this.form.IsExternalLink === null) {
        this.$set(this.form, 'IsExternalLink', 0)
      } else {
        this.$set(this.form, 'IsExternalLink', Number(this.form.IsExternalLink) === 1 ? 1 : 0)
      }
      if (Number(this.form.IsExternalLink) !== 1) {
        this.$set(this.form, 'ExternalLink', '')
      }
      let campusId = normalizeDeptId(row.CampusId)
      if (!campusId && this.campusOptions.length === 1) {
        campusId = normalizeDeptId(this.campusOptions[0].Id)
      }
      this.$set(this.form, 'CampusId', campusId || undefined)
      this.fileList = []
      if (row.Images) {
        const imgs = row.Images.split(',')
        this.fileList = await this.deferredPictureCardFromMedia(imgs)
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.dataForm) this.$refs.dataForm.clearValidate()
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该记录吗？', '提示', { type: 'warning' }).then(() => {
        removeClassActivity({ id: row.Id }).then(res => {
          if (res.data.success) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    submitForm() {
      this.$refs.dataForm.validate(async valid => {
        if (!valid) return
        if (this.form.IsExternalLink === 1 && !(this.form.ExternalLink || '').trim()) {
          this.$message.warning('开启外链时请填写完整链接地址')
          return
        }
        this.submitLoading = true
        const pd = Object.assign({}, this.form)
        pd.DepartmentId = this.DepartmentId
        pd.IsExternalLink = Number(pd.IsExternalLink) === 1 ? 1 : 0
        if (pd.IsExternalLink !== 1) pd.ExternalLink = ''
        else pd.ExternalLink = (pd.ExternalLink || '').trim()
        pd.CampusId = normalizeDeptId(pd.CampusId)
        if (!pd.CampusId) {
          this.submitLoading = false
          this.$message.warning('请选择校区')
          return
        }
        const imageUrls = await this.deferredPictureCardEnsure(this.fileList, 'ClassPortrait')
        pd.Images = imageUrls.join(',')
        saveClassActivity(pd).then(res => {
          this.submitLoading = false
          if (res.data.success) {
            this.$message.success('保存成功')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => { this.submitLoading = false })
      })
    },
    updateImagesPath() {
      const paths = this.fileList.map(file => this.deferredPictureCardItemPath(file)).filter(Boolean)
      this.$set(this.form, 'Images', paths.join(','))
    },
    handlePictureCardPreview(file) {
      this.previewImageUrl = file.url
      this.previewVisible = true
    }
  }
}
</script>

<style scoped>
.spa-page {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.spa-page .tbl-scroll-host {
  flex: 1;
  min-height: 0;
}

.merged-meta {
  line-height: 1.45;
  font-size: 13px;
  text-align: center;
}

.merged-meta-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.merged-meta-sub {
  color: #909399;
  font-size: 12px;
  margin-top: 2px;
}
</style>
